export const adsByPage = {
  "listing-search": [
    {
      label: "/21155722/emlakjet_web/ej_w_oop",
      sizes: `[[1, 1]]`,
      id: "div-gpt-ad-1629981973945-0",
      outOfPage: true,
    },
    {
      label: "/21155722/emlakjet_web/ej_w_masthead_728x90",
      sizes: `[[728, 90], [970, 90], 'fluid']`,
      id: "div-gpt-ad-1733492200314-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_listing_native",
      sizes: `['fluid', [728, 90], [825, 156]]`,
      id: "div-gpt-ad-1568114437700-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_listing2_native",
      sizes: `['fluid', [728, 90], [825, 156]]`,
      id: "div-gpt-ad-1568114516687-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_listing3_native",
      sizes: `[[728, 90], [825, 156], 'fluid']`,
      id: "div-gpt-ad-1720011550847-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_listing4_native",
      sizes: `[[728, 90], [825, 156], 'fluid']`,
      id: "div-gpt-ad-1720011428178-0",
    },
    /* {
      label: "/21155722/emlakjet_web/ej_w_detail_footer1",
      sizes: `[[336, 280], "fluid", [300, 250]]`,
      id: "div-gpt-ad-1571904661378-0",
      lazy: true,
    },
    {
      label: "/21155722/emlakjet_web/ej_w_detail_footer2",
      sizes: `["fluid", [300, 250], [336, 280]]`,
      id: "div-gpt-ad-1571904715210-0",
      lazy: true,
    }, */
    {
      label: "/21155722/emlakjet_web/ej_w_footer_970x250",
      sizes: `['fluid', [990, 250], [970, 250]]`,
      id: "div-gpt-ad-1691567946575-0",
    },
  ],
  "landing-page": [
    {
      label: "/21155722/emlakjet_web/ej_w_masthead_728x90",
      sizes: `[[728, 90], [970, 90], 'fluid']`,
      id: "div-gpt-ad-1733492200314-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_listing_native",
      sizes: `['fluid', [728, 90], [825, 156]]`,
      id: "div-gpt-ad-1568114437700-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_listing2_native",
      sizes: `['fluid', [728, 90], [825, 156]]`,
      id: "div-gpt-ad-1568114516687-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_listing3_native",
      sizes: `[[728, 90], [825, 156], 'fluid']`,
      id: "div-gpt-ad-1720011550847-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_listing4_native",
      sizes: `[[728, 90], [825, 156], 'fluid']`,
      id: "div-gpt-ad-1720011428178-0",
    },
    /* {
      label: "/21155722/emlakjet_web/ej_w_detail_footer1",
      sizes: `[[336, 280], 'fluid', [300, 250]]`,
      id: "div-gpt-ad-1571904661378-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_detail_footer2",
      sizes: `['fluid', [300, 250], [336, 280]]`,
      id: "div-gpt-ad-1571904715210-0",
    }, */
  ],
  "listing-detail": [
    {
      label: "/21155722/emlakjet_web/ej_w_projedetay_300x250",
      sizes: `[[300, 250], 'fluid', [336, 280]]`,
      id: "div-gpt-ad-1753440478617-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_detail_300x250",
      sizes: `[[300, 250], 'fluid', [336, 280]]`,
      id: "div-gpt-ad-1568113922617-0",
    },
    {
      label: "/21155722/emlakjet_web/ej_w_emlakci_detail",
      sizes: ["fluid", [300, 250], [336, 280]],
      id: "div-gpt-ad-1574774928572-0",
      lazy: true,
    },
  ],
  // "cyprus-landing": [
  //   {
  //     label: "/21155722/emlakjet_web/ej_w_kibris_1110x233",
  //     sizes: `[[1110, 233], 'fluid']`,
  //     id: "div-gpt-ad-1736750634044-0",
  //     lazy: true,
  //   },
  //   {
  //     label: "21155722/emlakjet_web/ej_t_kibris_727x233",
  //     sizes: `[[727, 233], 'fluid']`,
  //     id: "div-gpt-ad-1736850062847-0",
  //     lazy: true,
  //   },
  //   {
  //     label: "/21155722/emlakjet_web/ej_m_kibris_290x133",
  //     sizes: `[[290, 133], 'fluid']`,
  //     id: "div-gpt-ad-1736750755376-0",
  //     lazy: true,
  //   },
  // ],
};
